import type { CookieConsentCategory } from "@/shared/utils/cookieConsent";

import ShieldCheckeredIcon from "@/shared/icons/shield-checkered.svg";
import AdjustmentsIcon from "@/shared/icons/adjustments.svg";
import ChartBarIcon from "@/shared/icons/chart-bar.svg";
import SpeakerphoneIcon from "@/shared/icons/speakerphone.svg";
import PuzzleIcon from "@/shared/icons/puzzle.svg";

export type CookieCategoryDescriptor = {
  key: CookieConsentCategory;
  icon: typeof ShieldCheckeredIcon;
  required?: boolean;
};

export const COOKIE_CATEGORIES: CookieCategoryDescriptor[] = [
  { key: "necessary", icon: ShieldCheckeredIcon, required: true },
  { key: "functional", icon: AdjustmentsIcon },
  { key: "analytics", icon: ChartBarIcon },
  { key: "marketing", icon: SpeakerphoneIcon },
  { key: "thirdParty", icon: PuzzleIcon }
];
